var PopUp = (function() {
	var __private = {
		dataAttr: "data-popup-id",
		showClass: "show",
		closeClass: "popup__close",
		popup: false,

		listener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;
				
				var target = event.target;
				var ID = false;
				var close;
				var isPopup = __private.searchPoppup(target, ID);

				if(target.getAttribute(__private.dataAttr)) {
					event.preventDefault();

					ID = target.getAttribute(__private.dataAttr);
					__private.popup = document.getElementById(ID);

					if(__private.popup) __private.openPopup();
				}

				if(target.classList.contains(__private.closeClass)) {
					event.preventDefault();
					__private.closePopup();
				}
			});
		},

		openPopup() {
			if(this.popup) {
				this.popup.classList.add(this.showClass);
			}
		},

		closePopup() {
			if(this.popup) {
				this.popup.classList.remove(this.showClass);
			}
		},

		searchPoppup(elem, ID) {
			if(elem instanceof HTMLElement) {
				if(elem.getAttribute("id") === ID) return true;
				else if(elem !== document.body) return __private.searchPoppup(elem.parentElement, ID);
				else return false; 
			}
		}
	};

	return {
		init() {
			__private.listener();
		}
	};
})();

// Init script
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		
		var popupLinks = document.querySelectorAll("*[data-popup-id]");

		if(popupLinks.length !== 0) PopUp.init();

	});
})();